export enum AvailableLookupConsumer {
    calculator = "calculator",
    embedCalculator = "embedCalculator",
    coveragePortal = "coveragePortal",
    labelingPortal = "labelingPortal",
}

export enum AvailableLookupType {
    healthProviders = "health_providers",
    simplifiedPractices = "simplified_practices",
    payers = "payers",
    payerPrediction = "payer_prediction",
    cptCodes = "cpt_codes",
    zendeskSupportCategories = "support_ticket_categories",
    zipSessionRate = "zip_session_rate",
    labelingPortalTagsWithoutValues = "labeling_portal_tags_without_values",
    labelingPortalTagsWithValues = "labeling_portal_tags_with_values",
    labelingPortalServiceTypes = "labeling_portal_service_types",
}
